import React, { Component } from 'react';
import { Checkbox, Select, Box, MenuItem, FormLabel, FormControlLabel, FormHelperText } from '@mui/material';
import { AddCircleOutline as AddCircleIcon, RemoveCircleOutline as RemoveCircleIcon } from '@mui/icons-material';
import moment from 'moment';
import { startEndTimeValidator } from '../helpers';

class WeeklyHoursSelector extends Component {
  days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  hourRange = [];

  constructor(props) {
    super(props);
    this.state = {
      hours: props.initialValues || {},
    };
    this.generateHourRange();
  }

  handleDayToggle = name => event => {
    if (event.target.checked) {
      this.addTimeSlot(name, '08:00am', '10:00am');
    } else {
      this.setHoursForDay(name, []);
    }
  };

  addTimeSlot = (key, start, end) => {
    let { [key]: slots } = this.state.hours;
    if (typeof slots !== 'undefined') {
      slots.push({ start, end });
    } else {
      slots = [{ start, end }];
    }

    this.setHoursForDay(key, slots);
  };

  removeTimeSlot = (day, index) => {
    const { [day]: slots } = this.state.hours;

    this.setHoursForDay(day, slots.filter((slot, sIndex) => sIndex !== index));
  };

  setHoursForDay = (day, slots) => {
    const newSlots = slots.map((slot) => {
      const timeValidator = startEndTimeValidator(moment(slot.start, 'hh:mma'), moment(slot.end, 'hh:mma'));

      return { ...slot, error: !!timeValidator.begin.message || !!timeValidator.end.message };
    });

    this.setState(
      state => ({
        ...state,
        hours: {
          ...state.hours,
          [day]: newSlots,
        },
      }),
      () => this.props.onChange(this.state.hours)
    );
  };

  onHourChange = (day, slotIndex, saveProperty) => event => {
    const { [day]: slots } = this.state.hours;
    this.setHoursForDay(
      day,
      slots.map((slot, index) => {
        if (index === slotIndex) {
          return {
            ...slot,
            [saveProperty]: event.target.value,
          };
        }

        return slot;
      })
    );
  };

  generateHourRange() {
    const date = moment('12:00am', 'hh:mma');
    let dateFormatted = date.format('hh:mma');

    while (date.isBefore(moment('11:59pm', 'hh:mma'))) {
      this.hourRange.push({ label: dateFormatted, value: dateFormatted });
      date.add(30, 'm');
      dateFormatted = date.format('hh:mma');
    }
  }

  renderTimeSlots = day => {
    const { [day]: timeSlots } = this.state.hours;

    const renderSelect = (label, value, day, slotIndex, saveProperty, validator) => (
      <Box maxWidth="280px">
        <Select
          variant="standard"
          value={value}
          options={this.hourRange}
          placeholder={label}
          onChange={this.onHourChange(day, slotIndex, saveProperty)}
        >
          {this.hourRange.map((hour, index) => (
            <MenuItem key={index} value={hour.value}>
              {hour.label}
            </MenuItem>
          ))}
        </Select>
        {!validator.isValid && <FormHelperText error>{validator.message}</FormHelperText>}
      </Box>
    );

    return (
      <div>
        {timeSlots &&
          timeSlots.length > 0 &&
          timeSlots.map((slot, index) => {
            const timeValidator = startEndTimeValidator(moment(slot.start, 'hh:mma'), moment(slot.end, 'hh:mma'));
            return (
              <Box
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '8px 5px' }}
                key={index}
              >
                {renderSelect('Begin', slot.start, day, index, 'start', timeValidator?.begin)}
                {renderSelect('End', slot.end, day, index, 'end', timeValidator?.end)}
                {index + 1 < timeSlots.length && (
                  <RemoveCircleIcon sx={{ cursor: 'pointer' }} onClick={() => this.removeTimeSlot(day, index)} />
                )}
                {index + 1 === timeSlots.length && (
                  <AddCircleIcon
                    sx={{ cursor: 'pointer' }}
                    onClick={() => this.addTimeSlot(day, '08:00am', '10:00am')}
                  />
                )}
              </Box>
            );
          })}
      </div>
    );
  };

  render() {
    const { hideTitle = false, hideBorder = false } = this.props;
    const { hours } = this.state;

    return (
      <Box>
        {!hideTitle && <FormLabel>Receiving hours</FormLabel>}
        <Box sx={{ display: 'flex', flexFlow: 'row wrap', gap: 1 }}>
          {this.days.map(day => (
            <Box
              sx={{
                flexGrow: 1,
                maxWidth: 280,
                flexBasis: 230,
                minWidth: { xs: '100%', sm: 'auto' },
                borderRight: hideBorder ? 'none' : '2px solid #eaeaea',
                '&:last-child': {
                  border: 'none',
                },
              }}
              key={day}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={this.handleDayToggle(day)}
                    checked={hours.hasOwnProperty(day) && hours[day].length > 0}
                    value={day}
                    color="primary"
                  />
                }
                label={day}
              />
              {this.renderTimeSlots(day)}
            </Box>
          ))}
        </Box>
      </Box>
    );
  }
}

export default WeeklyHoursSelector;
